import React from 'react'
import ReactToPrint from "react-to-print";
import { numberToWords } from "amount-to-words";

const PurchaseRec = (props) => {
    const { discount, total } = props;

    function getDate(date){
        const originalDate = new Date(date);
        const formattedDate = originalDate.toISOString().split('T')[0];
        return formattedDate
    }

    const componentRef = React.createRef();
    return (
        <>
            <div className="purchaseorder__preview bg-white p-5 rounded-2xl border-4 border-blue-200  ">
                <ReactToPrint
                    trigger={() => (
                        <button className="bg-blue-500 ml-5 text-white font-bold py-2 px-8 rounded hover:bg-blue-600 hover:text-white transition-all duration-150 hover:ring-4 hover:ring-blue-400">
                            Print / Download
                        </button>
                    )}
                    content={() => componentRef.current}
                />
                <div ref={componentRef} className="py-5 px-8 flex flex-col min-h-full print:w-[210mm] print:h-[100mm] relative">

                    <div>
                        <div className="flex flex-col items-center justify-center mb-5 xl:flex-row xl:justify-center w-full">
                            <div>

                                <img  src={props.companylogo} alt="logo" />
                            </div>
                        </div>
                        <article className=" py-2 text-center text-base text-black border-t border-b border-black uppercase w-full font-bold">
                            {props.purchase_number ? (
                                <p>purchase</p>
                            ) : props.purchaseordernumber ? (
                                <p>purchase order</p>
                            ) : (<p>purchase return</p>)}
                        </article>
                        <div className=" flex justify-between my-5">
                            <article className=" flex items-start justify-start">
                                <ul>
                                    <li className="p-1 ">
                                        <span className="font-bold">Supplier:</span> {props.vendorname}
                                    </li>
                                    <li className="p-1">
                                        <span className="font-bold">Address:</span> {props.vendoraddress}
                                    </li>
                                    <li className="p-1">
                                        <span className="font-bold">Delivery Date:</span> {props?.deliveryDate?getDate(props.deliveryDate):"Not Applicable"}
                                    </li>
                                    <li className="p-1 ">
                                        <span className="font-bold">Phone:</span> {props.vendorphone}
                                    </li>
                                    <li className="p-1 ">
                                        <span className="font-bold">Delivery at:</span> AL RUKAIE CONTRACTING & TRADING CO.
                                    </li>
                                </ul>
                            </article>
                            <article className=" flex items-start justify-end">
                                <ul>
                                    {props.purchaseordernumber ? (
                                        <li className="p-1">
                                            <span className="font-bold">Purchase Number:</span> {props.purchaseordernumber}
                                        </li>
                                    ) : props.purchase_number ? (
                                        <li className="p-1">
                                            <span className="font-bold">Purchase Number:</span> {props.purchase_number}
                                        </li>
                                    ) : props.purchase_return_number ? (
                                        <li className="p-1">
                                            <span className="font-bold">Purchase Number:</span> {props.purchase_return_number}
                                        </li>
                                    ) : null}
                                    {props.podate ? (
                                        <li className="p-1">
                                            <span className="font-bold">purchase date:</span> {props.podate}
                                        </li>
                                    ) : (
                                        props.purchase_date && (
                                            <li className="p-1">
                                                <span className="font-bold">purchase date:</span> {props.purchase_date?.slice(0, 10)}
                                            </li>
                                        )
                                    )}
                                    <li className="p-1 ">
                                        <span className="font-bold">Time:</span> {props.time}
                                    </li>
                                    {/* <li className="p-1 ">
                                        <span className="font-bold">Date:</span> {props.time}
                                    </li> */}
                                    {/* {lpoNumber && ( */}
                                    <li className="p-1 ">
                                        <span className="font-bold">LPO No:</span> {props.vendorlpo}
                                    </li>
                                    {/* )} */}

                                </ul>
                            </article>
                        </div>

                        <table width="100%" className="mb-10">
                            <thead>
                                <tr className=" text-center bg-gray-100 p-1 py-2 text-base text-black border-t border-b border-black uppercase w-full font-semibold">
                                    <td className="font-bold">S.No.</td>
                                    <td className="font-bold">Item Code</td>
                                    <td className="font-bold">Description</td>
                                    <td className="font-bold">UOM</td>
                                    <td className="font-bold">Quantity</td>
                                    <td className="font-bold">Price</td>
                                    <td className="font-bold">Total</td>
                                </tr>
                            </thead>
                            {props.list?.map(({ id, itemdesc, uom, quantity, price, amount }, index) => (
                                <React.Fragment key={id}>
                                    <tbody>
                                        <tr className=" text-center h-10">
                                            <td>{index + 1}</td>
                                            <td>{id}</td>
                                            <td>{itemdesc}</td>
                                            <td>{uom}</td>
                                            <td>{quantity}</td>
                                            <td>{price}</td>
                                            <td>{amount}</td>
                                        </tr>
                                    </tbody>
                                </React.Fragment>
                            ))}
                        </table>

                        <div className="pl-2 pr-2 flex border-[3px] border-black rounded-lg flex-row items-center justify-evenly gap-2">
                            <div className="flex flex-col justify-center items-start gap-1">
                                <h2 className="flex text-gray-800 text-1xl font-semibold">
                                    In words
                                </h2>
                                <h2 className="flex text-gray-800 text-[17px] font-bold">
                                    (QR. {numberToWords(total)} Only)
                                </h2>
                            </div>
                            <div className="flex flex-col justify-center items-start gap-1">
                                <h2 className="flex text-gray-800 text-[13px] font-bold">
                                    TOTAL
                                </h2>
                                <h2 className="flex text-gray-800 text-1xl font-semibold">
                                    Discount in Amount
                                </h2>
                                <h2 className="flex text-gray-800 text-[13px] font-bold">
                                    NET TOTAL
                                </h2>
                            </div>
                            <div className="flex flex-col justify-center items-start gap-1">
                                <h2 className="flex text-gray-800 text-[17px] font-bold">
                                    {Math.round(total) + Math.round(discount)}
                                </h2>
                                <h2 className="flex text-gray-800 text-1xl font-semibold">
                                    {discount}
                                </h2>
                                <h2 className="flex text-gray-800 text-[17px] font-bold">
                                    {Math.round(total).toLocaleString()}
                                </h2>
                            </div>
                        </div>
                    </div>

                    <section className="mt-2 w-full flex flex-row justify-between items-start gap-2 mb-2">
                        <h3 className="font-bold">Note:-</h3>
                        <div className="flex w-[70%] flex-col justify-center items-start gap-1">
                            <p className="w-full text-justify">1. Order placed subject to the goods being supplied by in compliance with the agency laws of the country and the vendor has attained all necessary permits.</p>
                            <p className="w-full text-justify">2. Orginal LPO to be submitted along with the delivery.</p>
                            <p className="w-full text-justify">3. All the products must have Barcode.</p>
                            <p className="w-full text-justify">4. Products not moving with in 90 days will be returned back without any consent.</p>
                            <p className="w-full text-justify">5. The Product will be returned, <span className="underline font-semibold capitalize">2 MONTHS BEFORE EXPIRY</span>, without any consent.</p>
                            <p className="w-full text-justify">6. THIS LPO IS VALID FOR <span className="underline font-bold capitalize">15 DAYS ONLY.</span></p>
                        </div>
                        <div className="flex flex-col mt-[70px] gap-4 justify-center items-center">
                            <p className="lg:w-full text-center">Approved By</p>
                            <div className="w-full border-b-black border-2"></div>
                        </div>
                    </section>

                    {props.notes &&
                        <section className="mt-2 mb-2">
                            <h3 className="font-bold">Remarks:</h3>
                            <p className="lg:w-1/2 text-justify">{props.notes}</p>
                        </section>
                    }

                    <footer className=" footer border-t-2 border-gray-300 pb-5">
                        <ul className="flex flex-wrap items-center gap-2 justify-center">
                            <li>
                                <span className="font-bold">Email:</span> {"arcoglassqatar@gmail.com"}
                            </li>
                            <li>
                                <span className="font-bold">Tel:</span> {"4460 5198"}<span className="ml-1 font-bold">-Fax:</span> {"4451 7172"}
                            </li>
                            <li>
                                <span className="font-bold">P.O Box:</span> {"40992, Doha-Qatar "}
                            </li>
                        </ul>
                        <p className="text-center px-5 mt-4 text-xs ">
                            Thankyou for your purchase!
                        </p>
                    </footer>

                </div>
            </div>
        </>
    )
}

export default PurchaseRec